import iconUrl from '../assets/console-icon.png';

/** 管理画面のロゴ（サーバーコンソールのアイコン） */
export function BrandMark() {
  return <img className="brand-mark" src={iconUrl} alt="" width={22} height={22} />;
}
